import { DateTime } from "luxon";
import type { FC } from "react";
import { smallTimestampStyle } from "./styles.js";

export interface FullAbsoluteTimestampProps {
  timestamp: string;
  className?: string;
}

/** Shows a timestamp with small font size that includes the full date, time, and time zone abbreviation. */
export const FullAbsoluteTimestamp: FC<FullAbsoluteTimestampProps> = (
  props,
) => {
  return (
    <time
      className={smallTimestampStyle({ className: props.className })}
      dateTime={props.timestamp}
    >
      {DateTime.fromISO(props.timestamp).toLocaleString(DateTime.DATETIME_FULL)}
    </time>
  );
};
